<section class="client-feedback-component-section-wrapper" xmlns="http://www.w3.org/1999/html">
  <div class="client-feedback-component-wrapper" *ngFor="let feed of clientFeedbacks">
    <div class="client-feedback-component-wrapper_img-and-name-stars-w">
      <div class="client-feedback-component-wrapper_img-and-name-stars-w_profile-img-w">
        <img src="assets/images/default-avatar.png" alt="profile image">
      </div>

      <div class="client-feedback-component-wrapper_img-and-name-stars-w_name-and-stars-w">
        <div class="client-feedback-component-wrapper_img-and-name-stars-w_name-and-stars-w_review-name-w">
          <p>{{ feed.reviewerName | translate }}</p>
          <i>{{ feed.reviewerCompany | translate }}</i>
        </div>

        <div class="client-feedback-component-wrapper_img-and-name-stars-w_name-and-stars-w_review-stars-img-w">
          <img *ngFor="let _ of Array.from({ length: feed.rating })" src="assets/svgs/star.svg" alt="star">
        </div>
      </div>
    </div>

    <div class="client-feedback-component-wrapper_review-text-w">
      <p>{{feed.feedback  | translate }}</p>
      <p>{{ "feedback-industry" | translate }}: {{feed.industry}}</p>
    </div>
  </div>

</section>
